import http from '@/utils/request';
import global_ from '@/utils/Global'
let apiUrl_ZS  = global_.BASE_URL_ZS ;
let apiUrl  = global_.BASE_URL ;


/*获取数据列表*/
export const getDataList = params => {
  return http.requestPost(apiUrl_ZS + 'layout_head/get_head_info', params)
}
/*获取模板标签*/
export const get_select_config = params => {
  return http.requestPost(apiUrl_ZS + 'layout_model/get_select_config', params)
}

/*获取用户信息*/
export const getUserID = params => {
  return http.requestPost(apiUrl + '/web_serve/get_user_base_info', params)
}

/*检查用户是否登录*/
export const checkUserIsLogin = params => {
  return http.requestPost(apiUrl_ZS + 'login/check_user_session', params)
}
/*退出登录*/
export const logout = params => {
  return http.requestPost(apiUrl_ZS + 'login/logout', params)
}


// WEBPACK FOOTER //
// ./src/components/page/header/api/header.js